<template>
	<div>
		<iMineTemplate :pageTitle="pageTitle" :activedParentKey="activedParentKey" :activedKey="activedKey">
			<template #rightContent>
				<div class>
					<div class="bgfff pt20 pl20 pr20 order-list">
						<h6>退款/售后</h6>
						<div class="mt5">
							<iOrderListRefund
								v-if="refundDataList && refundDataList.length"
								:data="refundDataList"
								@goDetails="goDetails"
							/>
					
							<EmptyControl
								style="padding-top: 100px;"
								v-if="!refundDataList.length && refundFinished"
								type="order"
								:text="`还没有退款/售后订单哦～`"
								homeButton
							></EmptyControl>
						</div>
					</div>
					<iPagination
						:currentPage.sync="page.Pageindex"
						:limit.sync="page.Pagesize"
						:totalCount="page.count"
						@turn="onLoad"
						v-if="refundDataList && refundDataList.length"
						small
					/>
				</div>
			</template>
		</iMineTemplate>
	</div>
</template>
<script>
import iOrderListRefund from '@/components/iOrderListRefund';
import { BaseMixin } from '../../mixins/BaseMixin.js';
export default {
	name: 'AfterSale',
	mixins: [BaseMixin],
	components: {
		iOrderListRefund,
	},
	data() {
		return {
			orderInvoiceType: 1,
			pageTitle: ['交易管理', '我的订单'],
			activedParentKey: 2,
			activedKey: 23,
			refundDataList: [],
			refundFinished: false,
			// 退款数据分页参数
			page: {
				Pageindex: 1, //页数
				Pagesize: 10, //每页条数
				IsPagging: true, //是否开启分页
				count: 0 //总数
			}
		};
	},
	mounted() {
		// 获取订单数量统计
		this.onLoad();
	},
	methods: {
		async againLoad() {
			this.page.Pageindex = 1
			await this.loadData()
		},
		// 订单详情
		goDetails(id) {
				this.$router.push({
					path: 'OrderRefundDetails',
					query: {
						orderId: id
					}
				});
		},
		// 加载数据
		async onLoad() {
			await this.loadData();
		},
		async loadData() {
				// 获取退款/售后 数据
				this.$hys.openLoading();
				const refundRes = this.postAction('/api_aftersale/AfterSaleDocment/AfterSaleOrderList', {
					Pageindex: this.page.Pageindex, //页数
					Pagesize: this.page.Pagesize, //行数
					IsPagging: this.page.IsPagging //是否开启分页
				}).then(refundRes => {
					this.$hys.clearLoading();
					if (refundRes.IsSuccess) {
						// 设置总数
						this.page.count = refundRes.Count;
						if (this.page.Pageindex === 1) {
							this.refundDataList = [];
						}
						if (refundRes.Data.length < this.page.Pagesize) {
							this.refundFinished = true;
						}
						if (refundRes.Data) {
							let refundDataArr = []
							refundRes.Data.forEach(refundItem => {
								refundItem.status = '已退款'
								refundDataArr.push(refundItem)
							})
							this.refundDataList = refundDataArr;
						}
					} else {
						this.$toast({ position: 'bottom', message: refundRes.Msg });
						this.refundFinished = true;
					}
				});
		}
	}
};
</script>
<style lang="less" scoped>
.order-list {
	border-radius: 2px;
	border: 1px solid rgba(232, 232, 232, 1);
	width: 100%;
	box-sizing: border-box;
	padding-bottom: 30px;
	min-height: 668px;
	h6{
		color: #222222;
		font-size: 16px;
		text-align: left;
		margin-bottom: 30px;
	}
	/deep/.van-tabs {
		/deep/.van-tabs__wrap {
			border-bottom: 2px solid #3183ec;
		}
	}

	/deep/.van-tab {
		justify-content: flex-start;
		width: 125px;
		flex: none;
		align-items: flex-start;
	}
}

.middle-h {
	left: 0;
	right: 0;
	margin: auto;
}

/deep/.van-overlay {
	.wrapper {
		max-width: 1200px;
		margin: 5% auto;
	}

	.wrapper.logistics {
		width: 960px;
	}
}
</style>
